import { useCurrentWorkspace } from "@radarly/core/workspace/use-cases";
import { useProjectFacets } from "./useProjectFacets";
import { useWorkspaceFacets } from "./useWorkspaceFacets";

export function useFacetsFromContext() {
  const workspace = useCurrentWorkspace();
  const projectFacets = useProjectFacets();
  const workspaceFacets = useWorkspaceFacets();
  if (workspace) return workspaceFacets;
  return projectFacets;
}
